import React,{useState,useEffect} from "react"; 
import Chart from "chart.js/auto"; 
import { Pie } from "react-chartjs-2"; 


const PieChart = ({ items }) => 
  {
       let [cdata, setCdata] = useState(items);   
    let data = {
    labels: [
        "Moving",
        "Parked",
        "No Network",    
      ],
    datasets: [
      {
        label: "Avt Bharat",
        backgroundColor: [
          "#298502",
          "#ffeb3b",
          "#eb1717",
          "#eb0000",
          "#DD1C1A",
          "#FF8600",
          "#0E2F44",
        ],
        borderColor: "#fff",
        borderWidth: 1,
        hoverBackgroundColor: [
          "#9bdfc3",
          "#f9e9ba",
          "#ffa67b",
          "#6b0f12",
          "#b25800",
          "#041f2b",
        ],
        hoverBorderColor: "#000",
        data: items,
      },
    ],
  };
  return (
    <div >        
      <Pie data={data} /> 
    </div>
  );
};

// PieChart component is exported as default module.
export default PieChart;